"use strict";

export default {
  setAccessToken(state, payload) {
    state.accessToken = payload;
  },
};
